import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { autoinject, transient } from "aurelia-framework";
import { MepLookupItemCheckbox, MepPortMenuItemCheckbox } from "../../../../../../../../models/mep/mep.models";
import { RightShipDialogServiceConstants } from "../../../../../../../../constants/basics/rightship-dialog.constants";
import { MepService } from "../../../../../../../../services/mep/mep.service";

@autoinject()
@transient()
export class DownloadEmissionsDataDialog {

    public selectAllYears: boolean;
    public selectAllPorts: boolean;
    public generatingData: boolean;
    public isRequestDownloadDisabled: boolean;
    public years: MepLookupItemCheckbox[];
    public ports: MepPortMenuItemCheckbox[];

    constructor(private dialogClientService: DialogClientService, private mepService: MepService) {
    }

    public activate(params) {
        this.ports = params.ports;
        this.years = params.years;
        this.generatingData = params.generatingData;

        //Select all ports by default
        this.selectAllPorts = true;
        this.ports.forEach(port => {
            port.isSelected = true;
        });

        if (this.years.length > 0) {
            this.years[0].isSelected = true;
        }

        if (this.years.every(year => year.isSelected)) {
            this.selectAllYears = true;
        }
    }
    
    public close() {
        this.dialogClientService.hide();
    }

    public async requestDownload() {
        this.dialogClientService.hide();
        await this.mepService.downloadEmissionsData({
            portIds: this.ports.filter(port => port.isSelected).map(port => port.portId),
            years: this.years.filter(year => year.isSelected).map(year => year.id)
        });

        //Show Generating Emissions Data dialog
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.GeneratingEmissionsDataDialog, null, true, false, false, 'center');
    }

    //Select all years checkbox
    public selectAllYearsChanged() {
        this.years.forEach(year => {
            year.isSelected = this.selectAllYears;
        });

        this.updateRequestDownloadState()
    }

    //Year checkbox
    public yearSelectedChanged() {
        if (this.years.every(year => year.isSelected)) {
            this.selectAllYears = true;
        }
        else if (this.years.some(year => !year.isSelected)) {
            this.selectAllYears = false;
        }

        this.updateRequestDownloadState()
    }

    //Select all ports checkbox
    public selectAllPortsChanged() {

        this.ports.forEach(port => {
            port.isSelected = this.selectAllPorts;
        });

        this.updateRequestDownloadState()
    }

    //Port checkbox
    public portSelectedChanged() {
        if (this.ports.every(port => port.isSelected)) {
            this.selectAllPorts = true;
        }
        else if (this.ports.some(port => !port.isSelected)) {
            this.selectAllPorts = false;
        }

        this.updateRequestDownloadState()
    }

    updateRequestDownloadState() {
        this.isRequestDownloadDisabled = !this.years.some(year => year.isSelected) || !this.ports.some(port => port.isSelected);
    }
}